import React from 'react'

const Link = ({ href, children, style, dark, target }) => (
  <a
    target={target}
    style={{
      textDecoration: 'underline',
      color: !dark ? 'rgb(13, 68, 97)' : 'white',
      fontWeight: 'normal',
      ...style,
    }}
    href={href}
  >
    {children}
  </a>
)

export default Link



// WEBPACK FOOTER //
// ./src/components/Link/index.js